import { supabase } from '@/integrations/supabase/client';

export async function getPendingVendorChanges() {
  const { data, error } = await supabase
    .from('products')
    .select('*')
    .or('draft_data.not.is.null,status.eq.updates_in_progress')
    .order('updated_at', { ascending: false });
  
  if (error) throw error;
  return data;
}

export async function getPendingNewProducts() {
  const { data, error } = await supabase
    .from('products')
    .select('*')
    .eq('status', 'pending_review')
    .eq('is_published', false)
    .order('created_at', { ascending: false });
  
  if (error) throw error;
  return data;
}

export async function approveNewProduct(productId: string) {
  const { error } = await supabase
    .from('products')
    .update({ 
      status: 'published',
      is_published: true,
    })
    .eq('id', productId);
  
  if (error) throw error;
}

export async function rejectNewProduct(productId: string, reason?: string) {
  const { error } = await supabase
    .from('products')
    .update({ 
      status: 'rejected',
      is_published: false,
    })
    .eq('id', productId);
  
  if (error) throw error;
}

export async function approveDraftChanges(productId: string) {
  // First, get the product with draft_data
  const { data: product } = await supabase
    .from('products')
    .select('draft_data')
    .eq('id', productId)
    .single();
  
  if (!product?.draft_data) throw new Error('No draft data to approve');
  
  // Merge draft_data into live columns
  const updates = {
    ...(product.draft_data as any),
    draft_data: null, // Clear draft
    status: 'published',
  };
  
  const { error } = await supabase
    .from('products')
    .update(updates)
    .eq('id', productId);
  
  if (error) throw error;
}

export async function rejectDraftChanges(productId: string, rejectionReason?: string) {
  const { error } = await supabase
    .from('products')
    .update({ 
      draft_data: rejectionReason ? { rejection_reason: rejectionReason } : null,
      status: rejectionReason ? 'updates_rejected' : 'published',
    })
    .eq('id', productId);
  
  if (error) throw error;
}

